"use client"

import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  Stack,
  Link as MuiLink,
} from "@mui/material"
import { Upload, CheckCircle, FilePenLine as Signature, ArrowRight } from "lucide-react"
import { NavLink } from "react-router-dom"

export function DealTaskCommentsWidget() {
  const comments = [
    {
      id: 1,
      type: "Request",
      message: "Please upload the updated appraisal document for 789 Pine St.",
      action: "Upload Document",
      icon: <Upload size={18} style={{ color: "#3b82f6" }} />, // blue-500
    },
    {
      id: 2,
      type: "Approval",
      message: "Approval requested for the revised offer on 101 Maple Ave.",
      action: "Approve Document",
      icon: <CheckCircle size={18} style={{ color: "#22c55e" }} />, // green-500
    },
    {
      id: 3,
      type: "Signature",
      message: "Signature required on the closing documents for Commercial Lot.",
      action: "Sign Document",
      icon: <Signature size={18} style={{ color: "#a855f7" }} />, // purple-500
    },
  ]

  return (
    <Card elevation={2} sx={{ borderRadius: 2 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: "#0d2561" }}>
          Deal Task Comments
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "#6b7280", fontSize: "0.875rem", mb: 2 }}
        >
          New and pending deal-related messages and comments.
        </Typography>

        <Stack spacing={2}>
          {comments.map((comment) => (
            <Box key={comment.id} display="flex" gap={2} alignItems="flex-start">
              <Box flexShrink={0}>{comment.icon}</Box>
              <Box>
                <Typography variant="body2" fontWeight={500} sx={{ fontSize: "0.875rem" }}>
                  {comment.message}
                </Typography>
                <Button
                  size="small"
                  variant="text"
                  sx={{
                    p: 0,
                    minHeight: "auto",
                    mt: 0.5,
                    fontSize: "0.75rem",
                    textTransform: "none",
                  }}
                >
                  {comment.action}
                </Button>
              </Box>
            </Box>
          ))}
        </Stack>

        <Box mt={3} textAlign="right">
          <NavLink to="#" style={{ textDecoration: "none" }}>
            <Button
              variant="text"
              size="small"
              sx={{
                textTransform: "none",
                fontSize: "0.875rem",
                color: "#0d2561",
                p: 0,
                minHeight: "auto",
              }}
              endIcon={<ArrowRight size={16} />}
            >
              View all comments
            </Button>
          </NavLink>
        </Box>
      </CardContent>
    </Card>
  )
}
